<un-icon
  nz-dropdown
  [nzDropdownMenu]="menu"
  [nzPlacement]="'bottomCenter'"
  class="select-icon"
  type="ellipsis"
  theme="outline"
  size="large"
></un-icon>
<nz-dropdown-menu class="dropdown" #menu="nzDropdownMenu">
  <ul nz-menu nzMode="inline">
    @if (!hideView) {
    <li nz-menu-item>
      <a
        class="view"
        [routerLink]="viewLink"
        [queryParams]="viewLinkQuery"
        size="small"
        (view)="view.emit()"
      >
        <un-icon class="m-r-12" type="eye" theme="outline"></un-icon>
        <span i18n="@@view">View</span>
      </a>
    </li>
    } @if (!hideEdit) {
    <li nz-menu-item>
      <a
        class="edit"
        [routerLink]="editLink"
        size="small"
        (click)="edit.emit()"
      >
        <un-icon class="m-r-12" type="form" theme="outline"></un-icon>
        <span i18n="@@edit">Edit</span>
      </a>
    </li>
    } @if (!hideAssign) {
    <li nz-menu-item>
      <a class="assign" size="small" (click)="assign.emit()">
        <un-icon class="m-r-12" type="pushpin" theme="outline"></un-icon>
        <span i18n="@@assign">Assign</span>
      </a>
    </li>
    } @if (!hideNotes) {
    <li nz-menu-item>
      <a class="notes" size="small" (click)="openNotes.emit()">
        <nz-badge [nzCount]="notesCount" nzSize="small" [nzOverflowCount]="9">
          <un-icon class="m-r-12" type="snippets" theme="outline"></un-icon>
          <span class="m-r-8" i18n="@@notes">Notes</span>
        </nz-badge>
      </a>
    </li>
    } @if (!hideDelete) {
    <li nz-menu-item>
      <div
        class="delete"
        type="error"
        size="small"
        nz-popconfirm="This action can not be reverse?"
        i18n-nz-popconfirm="@@thisActionCanNotBeReverse"
        [nzPopconfirmOrigin]="elementRef"
        nzOkText="Delete"
        i18n-nzOkText="@@delete"
        [nzOkDanger]="true"
        (nzOnConfirm)="delete.emit()"
      >
        <un-icon class="m-r-12" type="delete" theme="outline"></un-icon>
        <span i18n="@@assign">Delete</span>
      </div>
    </li>
    }
  </ul>
</nz-dropdown-menu>
